import classnames from 'classnames';
import type { ArgumentArray } from 'classnames';
import { type ClassValue, clsx } from 'clsx';

import { Maybe } from './types';

// TODO(alesmraz): Remove this utils and use emotion instead

/**
 * Low-level utility for handling dynamic prefix/modifiers.
 * @deprecated Use emotion instead
 */
export const item = (
	prefix: string,
	modifiers: Maybe<ArgumentArray> | boolean,
	classes: Maybe<ArgumentArray> | boolean
): string => {
	const blissClass = [prefix];
	const normalizedModifiers = modifiers ? classnames(modifiers) : false;
	const normalizedClasses = classes ? classnames(classes) : false;
	if (normalizedModifiers) {
		blissClass.push(
			normalizedModifiers
				.trim()
				.split(' ')
				.map((mod) => `${prefix}--${mod}`)
				.join(' ')
		);
	}

	if (normalizedClasses) {
		blissClass.push(normalizedClasses);
	}

	return blissClass.join(' ');
};

/**
 * High-level utility for handling Bliss module with dynamic name/modifiers.
 * @deprecated Use emotion instead
 */
export const blissModule = (
	moduleName: string,
	modifiers: Maybe<ArgumentArray> | boolean = false,
	classes: Maybe<ArgumentArray> | boolean = false
): string => {
	return item(moduleName, modifiers, classes);
};

/**
 * High-level utility for handling Bliss element with dynamic name/modifiers.
 * @deprecated Use emotion instead
 */
export const blissElement = (
	moduleName: string,
	elementName: string,
	modifiers: Maybe<ArgumentArray> | boolean = false,
	classes: Maybe<ArgumentArray> | boolean = false
): string => {
	return item(`${moduleName}-${elementName}`, modifiers, classes);
};

export const bm = blissModule;
export const be = blissElement;

export function mergeClasses(...inputs: ClassValue[]): string {
	return clsx(inputs);
}
